import { cn } from "../../utils/cn";
import * as React from "react";

interface TableTemplateProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}
const TableTemplate: React.FC<TableTemplateProps> = ({ children, className, ...props }) => {
  return (
    <div className="flex justify-center mt-4" {...props}>
      <div className={cn("w-3/4", className)}>
        <table className="min-w-full bg-white border border-gray-300 shadow-lg rounded-lg text-sm text-right text-gray-800">
          {children}
        </table>
      </div>
    </div>
  );
};
export default TableTemplate;